<template>
    <Attr :widget_id="widget_id" :attr_id="attr_id">
        <!-- <div class="attr-containerResize" :id="'containerResize'+attr.html_id"> -->
            <div class="label-sheet" v-if="attr.title && !attr.hideTitle" :for="attr.html_id">{{ attr.title }}</div>
            <div class="attr-tree-map" ref="attr_container">
                <!-- IE 2026 09 15 / ODOO-… (заказ Игоря): шестерёнка и легенда — островком, как у карты -->
                <div class="corner-island corner-island-tr">
                    <!-- IE 2026 09 14 / ODOO-… (заказ Игоря: легенда TreeMap): легенда-переключатель серии и измерений — как у карты; пункты «Field» / «Dimensions»
                         прежней сетки параметров над диаграммой переехали сюда, сама сетка скрыта (paramsGrid_hide).
                         Выкл: window.fe.set('ux.treemapLegend', false) -->
                    <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                    <div class="attr-treemap-legend-btn button-1 p-2" v-uiHelp="{ key: 'chart.treemap.legendBtn', state: () => (legendPanelVisible ? 'on' : 'off') }" v-if="legendEnabled && measures.length" :class="{'attr-treemap-btn-on': legendPanelVisible}"
                        v-wjTooltip="legendPanelVisible ? t('Hide legend') : t('Show legend')" @click="legendPanelVisible = !legendPanelVisible">
                        <i class="pi pi-tags"/>
                    </div>
                    <div class="attr-treemap-cog button-1 p-2" ref="cogButton" @click="onToggle_treeMapSettings" v-uiHelp="'chart.treemap.cog'">
                        <i class="pi pi-cog"/>
                    </div>
                </div>
                <!-- IE 2026 09 23 / ODOO-341407: i18n -->
                <div class="attr-treemap-panel" v-if="legendPanelVisible" @click.stop>
                    <div class="attr-treemap-panel-head">
                        <i class="pi pi-times attr-treemap-panel-close" v-uiHelp="'chart.treemap.legend.close'" :title="t('Close')" @click="legendPanelVisible = false"/>
                        <span>{{ t('Legend') }}</span>
                    </div>
                    <label class="attr-treemap-panel-row" v-for="m in measures" :key="m.binding" :class="{'is-active': m.binding === valueBinding}">
                        <input type="checkbox" :checked="m.binding === valueBinding" @change="setActiveMeasure(m.binding, $event)" v-uiHelp="{ key: 'chart.treemap.legend.measure', state: () => (m.binding === valueBinding ? 'on' : 'off') }"/>
                        <span class="attr-treemap-panel-title">{{ m.title || m.binding }}</span>
                    </label>
                    <div class="attr-treemap-panel-sub" v-if="dimensionFields.length" :title="t('Hierarchy levels of the tree map, in the order of the numbers')">{{ t('Dimensions') }}</div>
                    <label class="attr-treemap-panel-row" v-for="d in dimensionFields" :key="'d:' + d.binding" :class="{'is-active': dimIndex(d.binding) >= 0}">
                        <input type="checkbox" :checked="dimIndex(d.binding) >= 0" @change="toggleDimension(d.binding, $event)" v-uiHelp="{ key: 'chart.treemap.legend.dimension', state: () => (dimIndex(d.binding) >= 0 ? 'level ' + (dimIndex(d.binding) + 1) : 'off') }"/>
                        <span class="attr-treemap-panel-title">{{ d.title || d.binding }}</span>
                        <span class="attr-treemap-panel-ord" v-if="dimIndex(d.binding) >= 0">{{ dimIndex(d.binding) + 1 }}</span>
                    </label>
                </div>
                <wj-tree-map
                    :id="attr.html_id"
                    labelContent="{name}" 
                    :type="attr.attr_typeTreeMap||'Squarified'" 
                    :initialized="initialized" 
                    :palette="palette"
                    v-visible="handleVisibility"
                />
                    <!-- :binding="attr.tree_binding" -->
                    <!-- :bindingName="attr.tree_dimension" -->
                    <!-- :labelContent="attr.labelContent||{name}"  -->
                <!-- <div class="wj-error" tabindex="-1">We do need your name...</div> -->
            </div>
        <!-- </div> -->
    </Attr>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import '@mescius/wijmo.vue2.chart.hierarchical';
import { isArray, Rect } from '@mescius/wijmo';
import { uiHelp_html, uiHelp_enabled, uiHelp_ownerYields } from '@/utils/uiHelp'   // U6 (заказ Игоря: объяснение элементов по Alt) · регрессия ie-dm7 #43146 (25.09)
import { Palettes } from '@mescius/wijmo.chart';

export default {
    props: [
        'widget_id',
        'attr_id',
    ],
    data: () => ({ 
        WIDGET: {},
        attr: {},                    // IE 2026 09 14 / ODOO-… (заказ Игоря: легенда TreeMap): реактивно, как у карты — computed легенды следят за tree_binding / tree_dimension
        legendPanelVisible: false,   // легенда открыта
    }),
    setup() {
        const store = useMainStore();
        return { store }
    },
    created() {
        // console.log(`created ${this.attr_id}`)
        this.WIDGET = this.store.findWidget(this.widget_id).WIDGET
        this.content_Changed()
        this.paramsGrid_hide()   // IE 2026 09 14 / ODOO-… (заказ Игоря: легенда TreeMap)

        this.palette = this.getRandomPalette()
    },
    computed: {
        // IE 2026 09 14 / ODOO-… (заказ Игоря: легенда TreeMap): поля диаграммы — как у карты (attrs диаграммы, иначе список полей записи)
        legendEnabled() { return this.store.setting('fe.ux.treemapLegend', true) !== false },
        fields() {
            // бэк кладёт в attrs диаграммы только поля из её параметров (текущие Field / Dimensions) — объединяем со
            // списком полей записи (viewList), иначе в легенде одна мера; свои attrs первыми (несут relation_segment)
            const own = this.attr?.attrs || []
            const rec = this.WIDGET?.record?.doc?.viewList || this.WIDGET?.record?.doc?.fields || []
            const seen = new Set(), out = []
            for (const f of this.store.fieldsNoHierarchy([...own, ...rec])) {
                if (!f || f.use === false || !f.binding || seen.has(f.binding)) continue
                seen.add(f.binding); out.push(f)
            }
            return out
        },
        // серии легенды — видимые числовые поля (значение = размер плитки)
        measures() {
            return this.fields.filter(a => (a.attr_type === 'AttrNumber' || a.attr_type === 'AttrDays' || a.attr_type === 'AttrTime') && !a.chart_hidden)
        },
        // измерения — нечисловые поля без дат и «.title» (как в content_Changed)
        dimensionFields() {
            const skip = new Set(['AttrNumber', 'AttrDays', 'AttrTime', 'AttrDate', 'AttrDateTime', 'AttrBool', 'AttrButton', 'AttrList'])
            return this.fields.filter(a => !skip.has(a.attr_type) && !String(a.binding).includes('date') && !String(a.binding).endsWith('.title'))
        },
        dimensions() {
            return String(this.attr?.tree_dimension || '').split(',').map(x => x.trim()).filter(Boolean)
        },
        valueBinding() {
            const b = this.attr?.tree_binding
            return (b && this.measures.some(m => m.binding === b)) ? b : (this.measures[0]?.binding || '')
        },
    },
    mounted() {
        this.WIDGET.attrsResize.push(this.attrResize)
    },
    methods: {
        // IE 2026 09 14 / ODOO-… (заказ Игоря: легенда TreeMap): смена серии / измерений из легенды — в viewParams записи (как прежняя сетка
        // параметров: doc.viewParams.<name>.tree_binding / tree_dimension) и перерисовка на месте — бэк эти параметры не читает
        viewParam_apply(param, value) {
            this.store.set_viewParam(this.WIDGET, this.attr.name, param, value, this.attr)
            if (this.attr[param] !== value) this.attr[param] = value
            this.content_Changed()
            this.flexRefresh()
        },
        setActiveMeasure(binding, ev) {
            if (binding === this.valueBinding) { if (ev?.target) ev.target.checked = true; return }   // одна активная серия
            this.viewParam_apply('tree_binding', binding)
        },
        dimIndex(binding) { return this.dimensions.indexOf(binding) },
        toggleDimension(binding, ev) {
            const list = this.dimensions.slice()
            const i = list.indexOf(binding)
            if (i >= 0) {
                if (list.length === 1) { if (ev?.target) ev.target.checked = true; return }   // хотя бы одно измерение
                list.splice(i, 1)
            } else list.push(binding)
            this.viewParam_apply('tree_dimension', list.join(','))
        },
        // хук store (set_viewParam из формы настроек / прежней сетки): применить и перерисовать
        set_viewParam(param, value) { this.viewParam_apply(param, value) },
        // сетка «Dimensions / Field» над диаграммой (AttrTabGrid attrs-params_AttrTreeMap-<name>, бэк-конфиг attr_tree_map) —
        // её пункты теперь в легенде; скрываем через use=false (AttrTab.filteredAttrs)
        paramsGrid_hide() {
            if (!this.legendEnabled || !this.attr?.name) return
            const grid = this.store.get_field0(this.WIDGET?.view, 'attrs-params_AttrTreeMap-' + this.attr.name, 'name')
            if (grid && grid.use !== false) grid.use = false
        },
        onToggle_treeMapSettings() {
            const vueObj = this
            const WRow = vueObj.store.get_childrenWidget(vueObj.WIDGET, 'widget-row')
            if (WRow && !WRow._softClosed && WRow.parentAction?.type === 'widget-row-viewParams' && WRow.record?._meta?.binding === this.attr.binding) {
                vueObj.store.widget_close(WRow.id)
                return
            }
            const cogEl = this.$refs.cogButton
            const widgetEl = document.getElementById('WIDGET' + vueObj.WIDGET.id)
            let x, y
            if (cogEl && widgetEl) {
                const cr = cogEl.getBoundingClientRect()
                const wr = widgetEl.getBoundingClientRect()
                x = cr.left - wr.left + cr.width / 2
                y = cr.top - wr.top + cr.height / 2
            }
            const actionMenu = {
                command: 'widget_open',
                widget: 'widget-row',
                type: 'widget-row-viewParams',
                source_attr_type: 'AttrTreeMap',
                binding: vueObj.attr.binding,
                source_name: vueObj.attr.name,
                get_Parent: true,
                open_in_children_widget: true,
                widgetRow_params: {
                    top_pct: 0.2,
                    left_pct: 0.2,
                    width_pct: 0.8,
                    height_pct: 0.8,
                },
                selectedCog: { x, y },
            }
            vueObj.store.executeStoreMethod(vueObj.WIDGET.vueObj, actionMenu, vueObj.attr)
        },
        content_Changed(command) {
            this.store.widget_attr_set(this)

            this.need_content_Changed_afterTimeout = true
            if (!this.isVisible) {
                return
            }

            if (this.content_Changed_timeout) { clearTimeout(this.content_Changed_timeout) }
            this.content_Changed_timeout = setTimeout(() => {
                this.content_Changed_afterTimeout(command)
            }, this.isVisible ? 1 : 700)
        },
        content_Changed_afterTimeout(command) {
            if (this.flex) {
                this.need_content_Changed_afterTimeout = false
                this.attrResize()
        
                const [doc, binding] = this.store.attr_get_link(this.WIDGET, this.attr)
                this.doc = doc, this.binding = binding
                this.flex.itemsSource = this.doc[this.binding] || []

                // if (this.doc[this.binding].length) {
                //     console.log(`this.doc[this.binding].length==${this.doc[this.binding].length} ${this.WIDGET.title}`)
                // } else {
                //     console.log('! this.doc[this.binding].length')
                // }
                if (this.flex.itemsSource.length) {
                    this.flex.binding = this.attr.tree_binding // this.WIDGET.record.doc?.params?.tree_binding || 'quantity' // this.attr.tree_binding
                    this.flex.bindingName = []
                    this.tree_dimension = (this.attr.tree_dimension || '')
                        .split(',')
                        .map(field => field.trim());
                    for (let bindingX of this.tree_dimension) {
                        let bindingX_added = false
                        if (!bindingX.includes('date') && !bindingX.endsWith('.title')) {
                            for (let attr of this.fields) {   // IE 2026 09 14 / ODOO-… (заказ Игоря: легенда TreeMap): и поля записи, не только attrs диаграммы
                                if (attr['binding'] === bindingX) {
                                    if (attr.relation_segment) { //  && attr.relation_segment==this.store.itemsSource.change_type
                                        // console.log(`watch ${this.store.itemsSource.change_type} ${newVal}`)
                                        const ids = [...new Set(
                                            (this.doc[this.binding] || [])
                                                .map(row => this.store.get_value(row, attr.binding))
                                                .filter(id => id && !String(id).startsWith('=') && !String(id).startsWith('#'))
                                        )]
                                        this.store.get_itemsSource(this, this.doc[this.binding], attr, {fill:'fill.title', ids})
                                        if (this.flex.itemsSource.length && `${attr['binding']}.title` in this.flex.itemsSource[0]) {
                                            this.flex.bindingName.push(`${attr['binding']}.title`)
                                        } else {
                                            // this.flex.bindingName.push(`${attr['binding']}`) // LOOK watch...
                                        }
                                        bindingX_added = true
                                        // this.flex.bindingX = `${attr['binding']}.title`
                                        // this.refresh()
                                        break
                                    }
                                }
                            }
                        }
                        if (!bindingX_added) this.flex.bindingName.push(bindingX)
                    }

                    for (let row of this.flex.itemsSource) {
                        row._quantity_map = this.store.get_value(row, this.flex.binding) || 0;
                    }
                    this.flex.binding = '_quantity_map'
                }
            }
        },
        initialized(flex) {
            this.flex = flex;
            this.uiHelp6_bindTiles(); flex.rendered.addHandler(() => this.uiHelp6_bindTiles())   // U6 (регрессия ie-dm7 #43146, 25.09)
            this.content_Changed()
        },
        // IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U6 (регрессия ie-dm7 #43146, 25.09): объяснение плиток — источником «по точке» на корне SVG, а не
        // директивой на хосте wj-tree-map: регистрация на хосте глушила собственную подсказку TreeMap (App.vue: хост с __wjTipFn — «ленивая»
        // подсказка, без Alt / Show tooltips не показывается). Подсказка — у курсора, без дожития после Alt; область владельца — уступает
        uiHelp6_bindTiles() {
            const svg = this.flex && this.flex.hostElement && this.flex.hostElement.querySelector('svg')
            if (!svg || svg.__altTipAt) return
            svg.__altTipAt = (x, y) => {
                if (!uiHelp_enabled() || uiHelp_ownerYields(svg, x, y)) return null
                const html = uiHelp_html('chart.treemap.tiles')
                return html ? { content: html, rect: new Rect(x - 8, y - 8, 16, 16), noLinger: true } : null
            }
            svg.setAttribute('data-alt-tip-at', '')
            svg.setAttribute('data-help-at', 'chart.treemap.tiles')
        },
        getRandomPalette() {
            let palettes = Object.keys(Palettes).filter(prop => isArray(Palettes[prop]));
            let rand = Math.floor(Math.random() * palettes.length);
            //
            return Palettes[palettes[rand]];
        },
        attrResize() {
            this.need_attrResize_afterTimeout = true
            if (!this.isVisible) {
                return
            }
            if (this.attrResize_timeout) { clearTimeout(this.attrResize_timeout) }
            this.attrResize_timeout = setTimeout(() => {
                this.attrResize_afterTimeout()
                this.attrResize_timeout = null
            }, 1)
        },
        attrResize_afterTimeout() {
            this.need_attrResize_afterTimeout = false
            if (!this.isVisible) return
            // console.log('attrResize')
            const elementForm = document.getElementById(`WIDGET${this.widget_id}`);
            // const elementForm = document.getElementById(`containerResize${this.attr.html_id}`)
            const elementFlex = document.getElementById(this.attr.html_id); // this.$refs.attr_container
            // const elementFlex = this.$refs.attr_container // document.getElementById(this.attr.html_id);
            if (!elementForm || !elementFlex) {
                return
            }
            const elementWidget_Rect = elementForm.getBoundingClientRect()
            const elementFlex_Rect = elementFlex.getBoundingClientRect()
            if (elementFlex_Rect.height) {
                let newHeight = Math.floor(elementWidget_Rect.bottom - elementFlex_Rect.top) - 2
                if (this.attr.size) {
                    newHeight = Math.round(newHeight * this.attr.size / 100)
                }
                if (newHeight < (this.attr.minHeight||160)) {
                    newHeight = (this.attr.minHeight||160)
                }
                if (this.attr.maxHeight && newHeight > this.attr.maxHeight) {
                    newHeight = this.attr.maxHeight
                } else if (newHeight > 1500) {
                    newHeight = 1500
                }
                if (this.attr.heightAdd) {
                    newHeight += this.attr.heightAdd
                }
                if (elementFlex_Rect.height !== newHeight) {
                    // console.log('attrResize' +(elementFlex_Rect.height - newHeight))
                    elementFlex.style.height = `${newHeight}px`
                }
            }
        },
        flexRefresh() {
            this.need_flexRefresh_afterTimeout = true
            if (!this.isVisible) {
                return
            }
            if (this.flexRefresh_timeout) { clearTimeout(this.flexRefresh_timeout) }
            this.flexRefresh_timeout = setTimeout(() => {
                this.flexRefresh_afterTimeout()
            }, this.isVisible ? 3 : 600)
        },
        flexRefresh_afterTimeout() {
            if (!this.need_flexRefresh_afterTimeout) {
                return
            }
            this.need_flexRefresh_afterTimeout = false
            this.flex.refresh()
        },
        handleVisibility(isVisible) {
            const vueObj = this
            if (vueObj.isVisible === isVisible) {
                return
            }
            vueObj.isVisible = isVisible
            if (isVisible) {
                if (this.attr.getSelectionWorkspace_date){
                    this.WIDGET.getSelectionWorkspace_date = this.getSelectionWorkspace_date
                }
                if (this.need_content_Changed_afterTimeout) {
                    this.content_Changed_afterTimeout()
                }
                if (this.need_flexRefresh_afterTimeout) {
                    this.flexRefresh_afterTimeout()
                }
                if (this.need_attrResize_afterTimeout) {
                    this.attrResize_afterTimeout()
                }
            }
        },
    },
    watch: {
        'store.itemsSource_change_index'(newVal, oldVal) {
            const changedSet = this.store.get_itemsSource_changedSet(newVal, oldVal)
            let isChanged = false
            if (!this.doc) return
            for (let bindingX of this.tree_dimension||[]) {
                let bindingX_added = false
                if (!bindingX.includes('date') && !bindingX.endsWith('.title')) {
                    for (let attr of this.fields) {   // IE 2026 09 14 / ODOO-… (заказ Игоря: легенда TreeMap)
                        if (attr['binding'] === bindingX) {
                            if (attr.relation_segment && (changedSet === null || changedSet.has(attr.relation_segment))) {
                                // console.log(`watch ${this.store.itemsSource.change_type} ${newVal}`)
                                this.store.get_itemsSource(this, this.doc[this.binding], attr, {fill:'fill.title', fetchMode: 'justGet'})
                                isChanged = true
                                // this.flex.bindingName.push(`${attr['binding']}.title`)
                                // bindingX_added = true
                                // this.flex.bindingX = `${attr['binding']}.title`
                                this.content_Changed()
                                // this.flexRefresh()
                                break
                            }
                        }
                    }
                }
                // if (!bindingX_added) this.flex.bindingName.push(bindingX)
            }
            if (isChanged) {
                this.flexRefresh()
            }
        }
    },
}
</script>

<style scoped>
.attr-tree-map {
    position: relative;
}
.attr-treemap-cog {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 10;
}
/* IE 2026 09 14 / ODOO-… (заказ Игоря: легенда TreeMap): кнопка и панель легенды — стиль панели карты (AttrGeoMap) */
.attr-treemap-legend-btn {
    position: absolute;
    top: 4px;
    right: 34px;
    z-index: 10;
}
.attr-treemap-btn-on {
    background: rgba(47, 59, 82, 0.12);
    border-radius: 4px;
}
.attr-treemap-panel {
    position: absolute;
    top: 36px;
    right: 8px;
    z-index: 20;
    min-width: 220px;
    max-height: 70vh;
    overflow: auto;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid #2f3b52;
    border-radius: 8px;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
    padding: 6px 8px 8px;
    font-size: 12px;
    color: #1f2937;
}
.attr-treemap-panel-head {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    margin-bottom: 4px;
}
.attr-treemap-panel-close {
    cursor: pointer;
    color: #c62828;
}
.attr-treemap-panel-row {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 2px;
    cursor: pointer;
    border-radius: 4px;
}
.attr-treemap-panel-row:hover {
    background: rgba(47, 59, 82, 0.08);
}
.attr-treemap-panel-row.is-active .attr-treemap-panel-title {
    font-weight: 600;
}
.attr-treemap-panel-sub {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid #e5e7eb;
    font-weight: 600;
    color: #4b5563;
}
.attr-treemap-panel-ord {
    margin-left: auto;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    border-radius: 8px;
    background: var(--cs-accent, #6477ef);
    color: white;
    font-size: 10px;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
</style>